import { Fragment, useState } from 'react';
import { Collapse, Tab, Tabs } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import clsx from 'clsx';
import he from 'he';

import style from './style.module.scss';

const tabProps = (index) => {
    return {
        id: `menu-tab-${index}`,
        'aria-controls': `menu-tabpanel-${index}`,
    };
};

export const MenuMobile = ({ items }) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Fragment>
            <Tabs value={value} onChange={handleChange} component="ul" className={style.tabs}>
                {items.map((item, index) => (
                    <Tab
                        key={'tab_' + item.ID}
                        label={item.title}
                        component="li"
                        className={style.tab}
                        {...tabProps(index)}
                    />
                ))}
            </Tabs>
            {items.map((item, index) => (
                <MobileMenuItemPanel key={'item_panel' + item.ID} items={item.children} value={value} index={index} />
            ))}
        </Fragment>
    );
};

const MobileMenuItemPanel = ({ items, value, index, ...props }) => {
    return (
        <ul
            role="tabpanel"
            hidden={value !== index}
            id={`menu-tabpanel-${index}`}
            aria-labelledby={`menu-tab-${index}`}
            className={style.panel}
            {...props}
        >
            {value === index &&
                items.map((item) => {
                    return item.children && item.children.length > 0 ? (
                        <MenuItemCollapse item={item} key={'menu_item_collapse' + item.ID} />
                    ) : (
                        <MenuItem item={item} key={'menu_item' + item.ID} />
                    );
                })}
        </ul>
    );
};

const MenuItemCollapse = ({ item }) => {
    const [open, setOpen] = useState(false);

    return (
        <li className={style.item}>
            <p className={style.title} onClick={() => setOpen((val) => !val)}>
                {he.decode(item.title)}
                {open ? <ExpandLess /> : <ExpandMore />}
            </p>
            <Collapse in={open} className={style.subMenu} component="ul">
                {item.children.map((childItem) => (
                    <MenuItem item={childItem} key={'menu_item' + childItem.ID} />
                ))}
            </Collapse>
        </li>
    );
};

const MenuItem = ({ item }) => {
    return (
        <li className={clsx(style.item, item.featured && style.featured)}>
            <a href={item.url} className={style.link}>
                {he.decode(item.title)}
            </a>
        </li>
    );
};
